import React, { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Switch,
  FormControlLabel,
  Button,
  Divider,
  CircularProgress,
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Chip,
  Stack,
  IconButton,
  MenuItem,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  ToggleButton,
  ToggleButtonGroup,
  Tabs,
  Tab,
  Radio,
  RadioGroup,
  FormControl,
  FormLabel,
  Slider
} from '@mui/material';
import axios from 'axios';
import Swal from 'sweetalert2';
import { HEADERS, HEADER_FORM_DATA } from '../../../API/UrlAndPaths';
import AddIcon from '@mui/icons-material/Add';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import ComputerIcon from '@mui/icons-material/Computer';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import Lottie from 'lottie-react';
import LiveStorePreview from './LiveStorePreview';
import AnimationSelectorDialog from './AnimationSelectorDialog';
import BurgerHamburgerAnimation from '../../../lottie/BurgerHamburgerFastFoodRestaurant.json';
import BurgerAnimation from '../../../lottie/Burger.json';
import OrderCompletedAnimation from '../../../lottie/Ordercompleted.json';
import SpecialOfferAnimation from '../../../lottie/specialoffer.json';
import OrderNowAnimation from '../../../lottie/Ordernow.json';
import OrderNowAnimation2 from '../../../lottie/OrderNowanimation.json';
import OrderAnimation from '../../../lottie/Order.json';
import SetMenuAnimation from '../../../lottie/setmenu.json';
import FireAnimation from '../../../lottie/Fire.json';
import BestSaleAnimation from '../../../lottie/Bestsale.json';
import LimitedOfferAnimation from '../../../lottie/limitedoffer.json';
import BigSaleAnimation from '../../../lottie/BigSale.json';
import PepperonFireAnimation from '../../../lottie/Pepperonfire.json';
import OrderNow2Animation from '../../../lottie/ordernow2.json';

// Common currencies
const CURRENCIES = [
  { code: 'USD', symbol: '$', name: 'US Dollar' },
  { code: 'AED', symbol: 'د.إ', name: 'UAE Dirham' },
  { code: 'EUR', symbol: '€', name: 'Euro' },
  { code: 'GBP', symbol: '£', name: 'British Pound' },
  { code: 'INR', symbol: '₹', name: 'Indian Rupee' },
  { code: 'SAR', symbol: 'ر.س', name: 'Saudi Riyal' },
  { code: 'QAR', symbol: 'ر.ق', name: 'Qatari Riyal' },
  { code: 'OMR', symbol: 'ر.ع', name: 'Omani Rial' },
  { code: 'KWD', symbol: 'د.ك', name: 'Kuwaiti Dinar' },
  { code: 'BHD', symbol: 'د.ب', name: 'Bahraini Dinar' },
  { code: 'CAD', symbol: 'C$', name: 'Canadian Dollar' },
  { code: 'AUD', symbol: 'A$', name: 'Australian Dollar' },
  { code: 'SGD', symbol: 'S$', name: 'Singapore Dollar' },
  { code: 'JPY', symbol: '¥', name: 'Japanese Yen' },
  { code: 'CNY', symbol: '¥', name: 'Chinese Yuan' }
];

const ANIMATION_LIBRARY = [
  { name: 'Burger Hamburger', file: 'BurgerHamburgerFastFoodRestaurant.json', data: BurgerHamburgerAnimation },
  { name: 'Burger', file: 'Burger.json', data: BurgerAnimation },
  { name: 'Order Completed', file: 'Ordercompleted.json', data: OrderCompletedAnimation },
  { name: 'Special Offer', file: 'specialoffer.json', data: SpecialOfferAnimation },
  { name: 'Order Now', file: 'Ordernow.json', data: OrderNowAnimation },
  { name: 'Order Now 2', file: 'OrderNowanimation.json', data: OrderNowAnimation2 },
  { name: 'Order', file: 'Order.json', data: OrderAnimation },
  { name: 'Set Menu', file: 'setmenu.json', data: SetMenuAnimation },
  { name: 'Fire', file: 'Fire.json', data: FireAnimation },
  { name: 'Best Sale', file: 'Bestsale.json', data: BestSaleAnimation },
  { name: 'Limited Offer', file: 'limitedoffer.json', data: LimitedOfferAnimation },
  { name: 'Big Sale', file: 'BigSale.json', data: BigSaleAnimation },
  { name: 'Pepperon Fire', file: 'Pepperonfire.json', data: PepperonFireAnimation },
  { name: 'Order Now 3', file: 'ordernow2.json', data: OrderNow2Animation }
];

let ffmpegSingleton = null;

const SellerEcommerceDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [slugTouched, setSlugTouched] = useState(false);
  const [mediaProcessing, setMediaProcessing] = useState(false);

  const [productsLoading, setProductsLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [productDialogOpen, setProductDialogOpen] = useState(false);
  const [productSaving, setProductSaving] = useState(false);
  const [productPickerSearch, setProductPickerSearch] = useState('');
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [sourceLoading, setSourceLoading] = useState(false);
  const [sourceList, setSourceList] = useState([]);
  const [warehouseLocationsLoading, setWarehouseLocationsLoading] = useState(false);
  const [warehouseLocations, setWarehouseLocations] = useState([]);
  const [detectingLocationForArea, setDetectingLocationForArea] = useState(null);
  const [previewDevice, setPreviewDevice] = useState('desktop');
  const [productTab, setProductTab] = useState(0);
  const [sourceTab, setSourceTab] = useState(0);
  const [specialComboItems, setSpecialComboItems] = useState([]);
  
  // Animation selector state
  const [animationDialogOpen, setAnimationDialogOpen] = useState(false);
  const [selectedProductForAnimation, setSelectedProductForAnimation] = useState(null);
  const [animationSettings, setAnimationSettings] = useState({
    enabled: false,
    file: '',
    position: 'top-right',
    trigger: 'hover',
    size: 80
  });
  const [productForm, setProductForm] = useState({
    _id: '',
    sourceType: 'PRODUCT',
    sourceId: '',
    trackStock: false,
    maxQtyPerOrder: 0,
    cost: 0,
    sellingPrice: 0,
    mainCategoryId: '',
    mainCategoryName: '',
    posCategoryId: '',
    posCategoryName: '',
    images: [],
    media: [],
    name: '',
    description: '',
    category: 'Others',
    price: 0,
    mrp: 0,
    imageUrl: '',
    isVeg: false,
    isAvailable: true,
    isPublished: false,
    sortOrder: 0,
    useExistingMedia: true
  });

  const [form, setForm] = useState({
    enabled: false,
    registeredStoreName: '',
    storeSlug: '',
    storeName: '',
    branding: {
      logoUrl: '',
      primaryColor: '#1976d2',
      accentColor: '#ff5722',
      textColor: '#111827',
      backgroundColor: '#ffffff',
      theme: 'modern',
      desktopTheme: 'swiggy',
      mobileTheme: 'swiggy'
    },
    banners: [],
    deliveryAreas: [],
    currency: {
      code: 'USD',
      symbol: '$',
      name: 'US Dollar'
    },
    paymentSettings: {
      enablePayAtCounter: true,
      enableOnlinePayment: false,
      gatewayProvider: ''
    }
  });

  const normalizeSlug = (input) => {
    const raw = String(input || '').trim().toLowerCase();
    return raw
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '-')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  };

  const uploadProductMedia = async (file) => {
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      Swal.fire('Error', 'File size must be less than 5MB', 'error');
      return;
    }
    try {
      const fd = new FormData();
      fd.append('file', file);
      const res = await axios.post('/api/upload/media', fd, HEADER_FORM_DATA);
      if (res.data?.success && res.data?.url) {
        setProductForm((prev) => ({
          ...prev,
          media: [...(Array.isArray(prev.media) ? prev.media : []), { url: res.data.url, mimeType: res.data.mimeType || '' }]
        }));
      } else {
        Swal.fire('Error', 'Upload failed', 'error');
      }
    } catch (e) {
      Swal.fire('Error', e?.response?.data?.message || e.message || 'Upload failed', 'error');
    }
  };

  const addAreaRow = () => {
    setForm((prev) => ({
      ...prev,
      deliveryAreas: [...(prev.deliveryAreas || []), { areaCode: '', areaName: '', locationId: '', warehouseId: '', latitude: '', longitude: '' }]
    }));
  };

  const updateArea = (idx, key, value) => {
    setForm((prev) => {
      const next = Array.isArray(prev.deliveryAreas) ? [...prev.deliveryAreas] : [];
      const row = { ...(next[idx] || {}) };
      row[key] = value;

      if (key === 'locationId') {
        const loc = (warehouseLocations || []).find((l) => String(l?._id) === String(value));
        row.warehouseId = loc?.warehouseId ? String(loc.warehouseId) : '';
      }

      next[idx] = row;
      return { ...prev, deliveryAreas: next };
    });
  };

  const removeArea = (idx) => {
    setForm((prev) => {
      const next = Array.isArray(prev.deliveryAreas) ? [...prev.deliveryAreas] : [];
      next.splice(idx, 1);
      return { ...prev, deliveryAreas: next };
    });
  };

  const detectLocationForArea = (idx) => {
    if (!navigator.geolocation) {
      Swal.fire('Error', 'Geolocation is not supported by your browser', 'error');
      return;
    }
    
    setDetectingLocationForArea(idx);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        updateArea(idx, 'latitude', latitude.toFixed(6));
        updateArea(idx, 'longitude', longitude.toFixed(6));
        setDetectingLocationForArea(null);
        Swal.fire({
          icon: 'success',
          title: 'Location Detected',
          text: `Latitude: ${latitude.toFixed(6)}, Longitude: ${longitude.toFixed(6)}`,
          timer: 2000
        });
      },
      (error) => {
        setDetectingLocationForArea(null);
        Swal.fire('Error', 'Failed to get your location. Please enable location access.', 'error');
      }
    );
  };

  const loadSourceList = async (type) => {
    setSourceLoading(true);
    try {
      if (type === 'INVENTORY') {
        const locId = String(form?.deliveryAreas?.[0]?.locationId || '').trim();
        if (!locId) {
          setSourceList([]);
          return;
        }
        const res = await axios.get(`/api/ecommerce-store/me/source/inventory?locationId=${encodeURIComponent(locId)}`, HEADERS);
        const data = Array.isArray(res.data?.data) ? res.data.data : [];
        setSourceList(data);
      } else {
        const res = await axios.get('/api/ecommerce-store/me/source/products', HEADERS);
        const data = Array.isArray(res.data?.data) ? res.data.data : [];
        setSourceList(data);
      }
    } catch (e) {
      setSourceList([]);
    } finally {
      setSourceLoading(false);
    }
  };

  const loadSpecialComboItems = async () => {
    try {
      const res = await axios.get('/api/ecommerce-store/me/source/special-combo', HEADERS);
      const data = Array.isArray(res.data?.data) ? res.data.data : [];
      setSpecialComboItems(data);
    } catch (e) {
      console.error('Failed to load special/combo items:', e);
      setSpecialComboItems([]);
    }
  };

  useEffect(() => {
    if (productDialogOpen) {
      loadSourceList(productForm?.sourceType);
      loadSpecialComboItems();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productDialogOpen, productForm?.sourceType, form?.deliveryAreas?.[0]?.locationId]);

  const buildStoreLink = (slug) => {
    if (!slug) return '';
    const base = process.env.REACT_APP_ECOMMERCE_STORE_DOMAIN || window.location.origin;
    const prefix = process.env.REACT_APP_ECOMMERCE_STORE_PATH_PREFIX ?? '/store';
    const safeBase = String(base || '').replace(/\/+$/g, '');
    const safePrefix = String(prefix || '').trim();
    if (!safePrefix) {
      return `${safeBase}/${slug}`;
    }
    const normalizedPrefix = safePrefix.startsWith('/') ? safePrefix : `/${safePrefix}`;
    return `${safeBase}${normalizedPrefix}/${slug}`;
  };

  const storeLink = useMemo(() => {
    if (!form.storeSlug) return '';
    return buildStoreLink(form.storeSlug);
  }, [form.storeSlug]);

  useEffect(() => {
    const load = async () => {
      setLoading(true);
      try {
        const res = await axios.get('/api/ecommerce-store/me', HEADERS);
        if (res.data?.success && res.data?.data) {
          const data = res.data.data;
          setForm({
            enabled: Boolean(data.enabled),
            registeredStoreName: data.registeredStoreName || '',
            storeSlug: data.storeSlug || '',
            storeName: data.storeName || '',
            branding: {
              logoUrl: data.branding?.logoUrl || '',
              primaryColor: data.branding?.primaryColor || '#1976d2',
              accentColor: data.branding?.accentColor || '#ff5722',
              textColor: data.branding?.textColor || '#111827',
              backgroundColor: data.branding?.backgroundColor || '#ffffff',
              theme: data.branding?.theme || 'modern',
              desktopTheme: data.branding?.desktopTheme || 'swiggy',
              mobileTheme: data.branding?.mobileTheme || 'swiggy'
            },
            banners: Array.isArray(data.banners) ? data.banners : [],
            deliveryAreas: Array.isArray(data.deliveryAreas) ? data.deliveryAreas : [],
            currency: {
              code: data.currency?.code || 'USD',
              symbol: data.currency?.symbol || '$',
              name: data.currency?.name || 'US Dollar'
            },
            paymentSettings: {
              enablePayAtCounter: data.paymentSettings?.enablePayAtCounter !== false,
              enableOnlinePayment: Boolean(data.paymentSettings?.enableOnlinePayment),
              gatewayProvider: data.paymentSettings?.gatewayProvider || ''
            }
          });
        }
      } catch (e) {
        // Silent for now; user may not have configured store yet
      } finally {
        setLoading(false);
      }
    };

    load();
  }, []);

  const loadWarehouseLocations = async () => {
    setWarehouseLocationsLoading(true);
    try {
      const res = await axios.get('/api/ecommerce-store/me/warehouse-locations', HEADERS);
      if (res.data?.success) {
        setWarehouseLocations(Array.isArray(res.data?.data?.locations) ? res.data.data.locations : []);
      } else {
        setWarehouseLocations([]);
      }
    } catch (e) {
      setWarehouseLocations([]);
    } finally {
      setWarehouseLocationsLoading(false);
    }
  };

  useEffect(() => {
    loadWarehouseLocations();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadProducts = async () => {
    setProductsLoading(true);
    try {
      const res = await axios.get('/api/ecommerce-store/me/products', HEADERS);
      if (res.data?.success) {
        setProducts(Array.isArray(res.data?.data) ? res.data.data : []);
      } else {
        setProducts([]);
      }
    } catch (e) {
      setProducts([]);
    } finally {
      setProductsLoading(false);
    }
  };

  useEffect(() => {
    if (form?.storeSlug) {
      loadProducts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [form?.storeSlug]);

  const updateField = (key) => (e) => {
    const value = e?.target?.value;
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const updateRegisteredName = (e) => {
    const value = e?.target?.value;
    const nextSlug = normalizeSlug(value);
    setForm((prev) => ({
      ...prev,
      registeredStoreName: value,
      storeSlug: nextSlug // Always auto-generate slug from registered name
    }));
  };

  const updateBranding = (key) => (e) => {
    const value = e?.target?.value;
    setForm((prev) => ({ ...prev, branding: { ...prev.branding, [key]: value } }));
  };

  const saveStore = async () => {
    if (!form.registeredStoreName) {
      Swal.fire('Missing Registered Name', 'Please enter Registered Store Name', 'warning');
      return;
    }
    if (!form.storeSlug) {
      Swal.fire('Missing Store Slug', 'Please enter Store Slug', 'warning');
      return;
    }

    setSaving(true);
    try {
      const res = await axios.post('/api/ecommerce-store/save', form, HEADERS);
      if (res.data?.success) {
        Swal.fire({ icon: 'success', title: 'Saved', timer: 1200, showConfirmButton: false });
        if (res.data?.data) {
          const data = res.data.data;
          setForm((prev) => ({
            ...prev,
            storeSlug: data.storeSlug || prev.storeSlug,
            enabled: Boolean(data.enabled)
          }));
        }
      } else {
        Swal.fire('Error', res.data?.message || 'Failed to save', 'error');
      }
    } catch (e) {
      Swal.fire('Error', e?.response?.data?.message || e.message || 'Failed to save', 'error');
    } finally {
      setSaving(false);
    }
  };

  const uploadProductImage = async (file) => {
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      Swal.fire('Error', 'File size must be less than 5MB', 'error');
      return;
    }
    if (!file.type.startsWith('image/')) {
      Swal.fire('Error', 'Product image must be an image', 'error');
      return;
    }

    try {
      const fd = new FormData();
      fd.append('image', file);
      const res = await axios.post('/api/upload/image', fd, HEADER_FORM_DATA);
      if (res.data?.success && res.data?.url) {
        setProductForm((prev) => ({ ...prev, imageUrl: res.data.url }));
      } else {
        Swal.fire('Error', 'Upload failed', 'error');
      }
    } catch (e) {
      Swal.fire('Error', e?.response?.data?.message || e.message || 'Upload failed', 'error');
    }
  };

  const openNewProduct = () => {
    if (!form?.storeSlug) {
      Swal.fire('Store not saved', 'Please save your store settings first.', 'warning');
      return;
    }
    setProductForm({
      _id: '',
      sourceType: 'PRODUCT',
      sourceId: '',
      trackStock: false,
      maxQtyPerOrder: 0,
      cost: 0,
      sellingPrice: 0,
      mainCategoryId: '',
      mainCategoryName: '',
      posCategoryId: '',
      posCategoryName: '',
      images: [],
      media: [],
      name: '',
      description: '',
      category: 'Others',
      price: 0,
      mrp: 0,
      imageUrl: '',
      isVeg: false,
      isAvailable: true,
      isPublished: false,
      sortOrder: 0,
      useExistingMedia: true
    });
    setProductDialogOpen(true);
  };

  const openEditProduct = (p) => {
    setProductForm({
      _id: p?._id || '',
      sourceType: p?.sourceType || 'PRODUCT',
      sourceId: p?.sourceId || '',
      trackStock: Boolean(p?.trackStock),
      maxQtyPerOrder: Number(p?.maxQtyPerOrder || 0) || 0,
      cost: Number(p?.cost || 0) || 0,
      sellingPrice: Number(p?.sellingPrice || 0) || 0,
      mainCategoryId: p?.mainCategoryId || '',
      mainCategoryName: p?.mainCategoryName || '',
      posCategoryId: p?.posCategoryId || '',
      posCategoryName: p?.posCategoryName || '',
      images: Array.isArray(p?.images) ? p.images : [],
      media: Array.isArray(p?.media) ? p.media : [],
      name: p?.name || '',
      description: p?.description || '',
      category: p?.category || 'Others',
      price: Number(p?.price || 0) || 0,
      mrp: Number(p?.mrp || 0) || 0,
      imageUrl: p?.imageUrl || '',
      isVeg: Boolean(p?.isVeg),
      isAvailable: p?.isAvailable !== false,
      isPublished: Boolean(p?.isPublished),
      sortOrder: Number(p?.sortOrder || 0) || 0,
      useExistingMedia: true
    });
    setProductDialogOpen(true);
  };

  const saveProduct = async () => {
    if (!String(productForm?.name || '').trim()) {
      Swal.fire('Missing Name', 'Please enter product name', 'warning');
      return;
    }

    setProductSaving(true);
    try {
      const payload = {
        ...productForm,
        sourceType: productForm?.sourceType || 'PRODUCT',
        sourceId: productForm?.sourceId || '',
        trackStock: Boolean(productForm?.trackStock),
        maxQtyPerOrder: Number(productForm?.maxQtyPerOrder || 0) || 0,
        cost: Number(productForm?.cost || 0) || 0,
        sellingPrice: Number(productForm?.sellingPrice || 0) || 0,
        mainCategoryId: productForm?.mainCategoryId || '',
        mainCategoryName: productForm?.mainCategoryName || '',
        posCategoryId: productForm?.posCategoryId || '',
        posCategoryName: productForm?.posCategoryName || '',
        images: Array.isArray(productForm?.images) ? productForm.images : [],
        media: Array.isArray(productForm?.media) ? productForm.media : [],
        price: Number(productForm?.price || 0) || 0,
        mrp: Number(productForm?.mrp || 0) || 0,
        sortOrder: Number(productForm?.sortOrder || 0) || 0
      };
      const res = await axios.post('/api/ecommerce-store/product/save', payload, HEADERS);
      if (res.data?.success) {
        Swal.fire({ icon: 'success', title: 'Saved', timer: 900, showConfirmButton: false });
        setProductDialogOpen(false);
        await loadProducts();
      } else {
        Swal.fire('Error', res.data?.message || 'Failed to save product', 'error');
      }
    } catch (e) {
      Swal.fire('Error', e?.response?.data?.message || e.message || 'Failed to save product', 'error');
    } finally {
      setProductSaving(false);
    }
  };

  const togglePublish = async (p) => {
    try {
      const res = await axios.post(
        '/api/ecommerce-store/product/publish',
        { _id: p?._id, isPublished: !p?.isPublished },
        HEADERS
      );
      if (res.data?.success) {
        setProducts((prev) =>
          prev.map((x) => (x?._id === p?._id ? { ...x, isPublished: !p?.isPublished } : x))
        );
      } else {
        Swal.fire('Error', res.data?.message || 'Failed to update publish status', 'error');
      }
    } catch (e) {
      Swal.fire('Error', e?.response?.data?.message || e.message || 'Failed to update publish status', 'error');
    }
  };

  const toggleSpecial = async (p) => {
    try {
      const res = await axios.post(
        '/api/ecommerce-store/product/save',
        { _id: p?._id, name: p?.name, isSpecial: !p?.isSpecial },
        HEADERS
      );
      if (res.data?.success) {
        setProducts((prev) =>
          prev.map((x) => (x?._id === p?._id ? { ...x, isSpecial: !p?.isSpecial } : x))
        );
      } else {
        Swal.fire('Error', res.data?.message || 'Failed to update special status', 'error');
      }
    } catch (e) {
      Swal.fire('Error', e?.response?.data?.message || e.message || 'Failed to update special status', 'error');
    }
  };

  const toggleCombo = async (p) => {
    try {
      const res = await axios.post(
        '/api/ecommerce-store/product/save',
        { _id: p?._id, name: p?.name, isCombo: !p?.isCombo },
        HEADERS
      );
      if (res.data?.success) {
        setProducts((prev) =>
          prev.map((x) => (x?._id === p?._id ? { ...x, isCombo: !p?.isCombo } : x))
        );
      } else {
        Swal.fire('Error', res.data?.message || 'Failed to update combo status', 'error');
      }
    } catch (e) {
      Swal.fire('Error', e?.response?.data?.message || e.message || 'Failed to update combo status', 'error');
    }
  };

  const deleteProduct = async (p) => {
    const result = await Swal.fire({
      title: 'Delete Product?',
      text: `Are you sure you want to delete "${p?.name}"? This action cannot be undone.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it',
      cancelButtonText: 'Cancel'
    });

    if (!result.isConfirmed) return;

    try {
      const res = await axios.post('/api/ecommerce-store/product/delete', { _id: p?._id }, HEADERS);
      if (res.data?.success) {
        setProducts((prev) => prev.filter((x) => x?._id !== p?._id));
        Swal.fire({ icon: 'success', title: 'Product deleted', timer: 1500, showConfirmButton: false });
      } else {
        Swal.fire('Error', res.data?.message || 'Failed to delete product', 'error');
      }
    } catch (e) {
      Swal.fire('Error', e?.response?.data?.message || e.message || 'Failed to delete product', 'error');
    }
  };

  const uploadLogo = async (file) => {
    if (!file) return;
    if (file.size > 5 * 1024 * 1024) {
      Swal.fire('Error', 'File size must be less than 5MB', 'error');
      return;
    }
    if (!file.type.startsWith('image/')) {
      Swal.fire('Error', 'Logo must be an image', 'error');
      return;
    }

    try {
      const fd = new FormData();
      fd.append('image', file);
      const res = await axios.post('/api/upload/image', fd, HEADER_FORM_DATA);
      if (res.data?.success && res.data?.url) {
        setForm((prev) => ({ ...prev, branding: { ...prev.branding, logoUrl: res.data.url } }));
      } else {
        Swal.fire('Error', 'Upload failed', 'error');
      }
    } catch (e) {
      Swal.fire('Error', e?.response?.data?.message || e.message || 'Upload failed', 'error');
    }
  };

  const uploadBannerMedia = async (file) => {
    if (!file) return;

    const MAX = 5 * 1024 * 1024;

    const compressVideoIfNeeded = async (inputFile) => {
      if (!inputFile.type.startsWith('video/')) return inputFile;
      if (inputFile.size <= MAX) return inputFile;

      setMediaProcessing(true);
      try {
        const { FFmpeg } = await import('@ffmpeg/ffmpeg');
        const { fetchFile } = await import('@ffmpeg/util');

        if (!ffmpegSingleton) {
          ffmpegSingleton = new FFmpeg();
        }

        if (!ffmpegSingleton.loaded) {
          await ffmpegSingleton.load();
        }

        const inputName = `input_${Date.now()}`;
        const outputName = `output_${Date.now()}.mp4`;

        await ffmpegSingleton.writeFile(inputName, await fetchFile(inputFile));

        // Pass 1: try moderate compression
        // We keep it simple: scale to 720p max width and set video bitrate.
        await ffmpegSingleton.exec([
          '-i', inputName,
          '-vf', 'scale=720:-2',
          '-c:v', 'libx264',
          '-preset', 'veryfast',
          '-b:v', '800k',
          '-c:a', 'aac',
          '-b:a', '96k',
          '-movflags', '+faststart',
          outputName
        ]);

        const data = await ffmpegSingleton.readFile(outputName);
        const blob = new Blob([data.buffer], { type: 'video/mp4' });
        const outFile = new File([blob], outputName, { type: 'video/mp4' });

        // Cleanup
        try {
          await ffmpegSingleton.deleteFile(inputName);
          await ffmpegSingleton.deleteFile(outputName);
        } catch (e) {
          // ignore
        }

        if (outFile.size > MAX) {
          throw new Error('Unable to compress under 5MB. Please choose a shorter video.');
        }
        return outFile;
      } finally {
        setMediaProcessing(false);
      }
    };

    try {
      const fileToUpload = await compressVideoIfNeeded(file);

      if (fileToUpload.size > MAX) {
        Swal.fire('Error', 'File size must be less than 5MB', 'error');
        return;
      }

      const fd = new FormData();
      fd.append('file', fileToUpload);
      const res = await axios.post('/api/upload/media', fd, HEADER_FORM_DATA);
      if (res.data?.success && res.data?.url) {
        const media = {
          type: fileToUpload.type.startsWith('video/') ? 'video' : 'image',
          url: res.data.url,
          mimeType: res.data.mimeType || fileToUpload.type,
          size: res.data.size || fileToUpload.size,
          originalName: res.data.originalName || fileToUpload.name,
          placement: 'top',
          showInCarousel: true
        };
        setForm((prev) => ({ ...prev, banners: [...(prev.banners || []), media].slice(0, 10) }));
      } else {
        Swal.fire('Error', 'Upload failed', 'error');
      }
    } catch (e) {
      Swal.fire('Error', e?.response?.data?.message || e.message || 'Upload failed', 'error');
    }
  };

  return (
    <Box sx={{ p: 3 }}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h5" fontWeight={700} gutterBottom>
          Ecommerce Store (Seller)
        </Typography>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            <Alert severity="info" sx={{ mb: 2 }}>
              Configure your public store page. Share the link with buyers: <b>{storeLink || '-'}</b>
            </Alert>

            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={form.enabled}
                      onChange={(e) => setForm((prev) => ({ ...prev, enabled: e.target.checked }))}
                    />
                  }
                  label="Enable Store"
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Registered Store Name (Unique)"
                  value={form.registeredStoreName}
                  onChange={updateRegisteredName}
                  helperText="This must be unique (example: thalipestore). Store slug will be auto-generated from this."
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  label="Store Slug (Auto-generated)"
                  value={form.storeSlug}
                  disabled
                  helperText="Auto-generated from Registered Store Name. Cannot be edited."
                  InputProps={{
                    readOnly: true
                  }}
                />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Store Name"
                  value={form.storeName}
                  onChange={updateField('storeName')}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  select
                  fullWidth
                  label="Currency"
                  value={form.currency?.code || 'USD'}
                  onChange={(e) => {
                    const selected = CURRENCIES.find(c => c.code === e.target.value);
                    if (selected) {
                      setForm(prev => ({ ...prev, currency: selected }));
                    }
                  }}
                  helperText="Currency for product prices"
                >
                  {CURRENCIES.map((curr) => (
                    <MenuItem key={curr.code} value={curr.code}>
                      {curr.symbol} {curr.code} - {curr.name}
                    </MenuItem>
                  ))}
                </TextField>
              </Grid>

              <Grid item xs={12} md={6}>
                <Alert severity="info" sx={{ height: '100%', display: 'flex', alignItems: 'center' }}>
                  Selected: <b>{form.currency?.symbol} {form.currency?.code}</b>
                </Alert>
              </Grid>
            </Grid>

            <Divider sx={{ my: 2 }} />

            <Typography variant="subtitle1" fontWeight={700} gutterBottom>
              Delivery Areas (Buyer Area → Warehouse Location)
            </Typography>
            <Alert severity="info" sx={{ mb: 2 }}>
              Buyer will select an area in store page. Inventory stock will be checked from the mapped warehouse location.
            </Alert>

            <Grid container spacing={2} sx={{ mb: 2 }}>
              {(form.deliveryAreas || []).map((a, idx) => (
                <React.Fragment key={idx}>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      label="Area Code"
                      value={a?.areaCode || ''}
                      onChange={(e) => updateArea(idx, 'areaCode', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={4}>
                    <TextField
                      fullWidth
                      label="Area Name"
                      value={a?.areaName || ''}
                      onChange={(e) => updateArea(idx, 'areaName', e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={3}>
                    <TextField
                      fullWidth
                      select
                      label={warehouseLocationsLoading ? 'Loading Locations...' : 'Warehouse Location'}
                      value={a?.locationId || ''}
                      onChange={(e) => updateArea(idx, 'locationId', e.target.value)}
                      disabled={warehouseLocationsLoading}
                      helperText="For inventory stock check"
                    >
                      <MenuItem value="">Select</MenuItem>
                      {warehouseLocations.map((l) => (
                        <MenuItem key={String(l?._id)} value={String(l?._id)}>
                          {l?.name || l?.shortCode || String(l?._id)}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      fullWidth
                      label="Latitude"
                      type="number"
                      value={a?.latitude || ''}
                      onChange={(e) => updateArea(idx, 'latitude', e.target.value)}
                      helperText="For GPS detection"
                      inputProps={{ step: 'any' }}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <TextField
                      fullWidth
                      label="Longitude"
                      type="number"
                      value={a?.longitude || ''}
                      onChange={(e) => updateArea(idx, 'longitude', e.target.value)}
                      helperText="For GPS detection"
                      inputProps={{ step: 'any' }}
                    />
                  </Grid>
                  <Grid item xs={12} md={1} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <IconButton
                      color="primary"
                      onClick={() => detectLocationForArea(idx)}
                      disabled={detectingLocationForArea === idx}
                      title="Detect current location"
                      sx={{ mt: -2 }}
                    >
                      {detectingLocationForArea === idx ? (
                        <CircularProgress size={24} />
                      ) : (
                        <MyLocationIcon />
                      )}
                    </IconButton>
                  </Grid>
                  <Grid item xs={12} md={1}>
                    <Button variant="outlined" color="error" onClick={() => removeArea(idx)} fullWidth sx={{ height: 56 }}>
                      X
                    </Button>
                  </Grid>
                </React.Fragment>
              ))}
              <Grid item xs={12}>
                <Button variant="outlined" onClick={addAreaRow}>
                  Add Area
                </Button>
              </Grid>
            </Grid>

            <Divider sx={{ my: 2 }} />

            <Typography variant="subtitle1" fontWeight={700} gutterBottom>
              Payment Options
            </Typography>
            <Alert severity="info" sx={{ mb: 2 }}>
              Choose which payment methods buyers can use on your public store.
            </Alert>

            <Grid container spacing={2} sx={{ mb: 2 }}>
              <Grid item xs={12} md={4}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={Boolean(form.paymentSettings?.enablePayAtCounter)}
                      onChange={(e) =>
                        setForm((prev) => ({
                          ...prev,
                          paymentSettings: {
                            ...(prev.paymentSettings || {}),
                            enablePayAtCounter: e.target.checked
                          }
                        }))
                      }
                    />
                  }
                  label="Enable Pay at Counter"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControlLabel
                  control={
                    <Switch
                      checked={Boolean(form.paymentSettings?.enableOnlinePayment)}
                      onChange={(e) =>
                        setForm((prev) => ({
                          ...prev,
                          paymentSettings: {
                            ...(prev.paymentSettings || {}),
                            enableOnlinePayment: e.target.checked
                          }
                        }))
                      }
                    />
                  }
                  label="Enable Online Payment"
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField
                  fullWidth
                  select
                  label="Gateway Provider"
                  value={form.paymentSettings?.gatewayProvider || ''}
                  onChange={(e) =>
                    setForm((prev) => ({
                      ...prev,
                      paymentSettings: {
                        ...(prev.paymentSettings || {}),
                        gatewayProvider: e.target.value
                      }
                    }))
                  }
                  disabled={!Boolean(form.paymentSettings?.enableOnlinePayment)}
                  helperText={
                    form.paymentSettings?.enableOnlinePayment
                      ? 'Select payment gateway for online payments'
                      : 'Enable Online Payment to choose gateway'
                  }
                >
                  <MenuItem value="">Select</MenuItem>
                  <MenuItem value="razorpay">Razorpay</MenuItem>
                  <MenuItem value="stripe">Stripe</MenuItem>
                  <MenuItem value="upi">UPI</MenuItem>
                </TextField>
              </Grid>
            </Grid>

            <Divider sx={{ my: 2 }} />

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
              <Typography variant="subtitle1" fontWeight={700} sx={{ flex: 1 }}>
                Products ({products.length})
              </Typography>
              <Button variant="contained" onClick={openNewProduct} startIcon={<AddIcon />}> 
                Add Product
              </Button>
            </Box>

            <Tabs value={productTab} onChange={(e, val) => setProductTab(val)} sx={{ mb: 2, borderBottom: 1, borderColor: 'divider' }}>
              <Tab label={`All (${products.length})`} />
              <Tab label={`Special Items (${products.filter(p => p.isSpecial).length})`} />
              <Tab label={`Combo Deals (${products.filter(p => p.isCombo).length})`} />
            </Tabs>

            {productsLoading ? (
              <Box sx={{ display: 'flex', justifyContent: 'center', py: 3 }}>
                <CircularProgress size={22} />
              </Box>
            ) : products.length === 0 ? (
              <Alert severity="info" sx={{ mb: 2 }}>
                No products added yet. Click "Add Product" and then publish it to show on buyer store page.
              </Alert>
            ) : (
              <Grid container spacing={2} sx={{ mb: 2 }}>
                {products
                  .filter(p => {
                    if (productTab === 0) return true;
                    if (productTab === 1) return p.isSpecial;
                    if (productTab === 2) return p.isCombo;
                    return true;
                  })
                  .map((p) => (
                  <Grid item xs={6} sm={6} md={4} lg={3} key={p?._id}>
                    <Paper 
                      sx={{ p: 2, borderRadius: 2, cursor: 'pointer' }}
                      onDoubleClick={() => {
                        setSelectedProductForAnimation(p);
                        setAnimationSettings({
                          enabled: p.animation?.enabled || false,
                          file: p.animation?.file || '',
                          position: p.animation?.position || 'top-right',
                          trigger: p.animation?.trigger || 'hover',
                          size: p.animation?.size || 80
                        });
                        setAnimationDialogOpen(true);
                      }}
                    >
                      <Box sx={{ display: 'flex', gap: 2 }}>
                        <Box
                          sx={{
                            width: 84,
                            height: 84,
                            borderRadius: 2,
                            bgcolor: '#f3f4f6',
                            overflow: 'hidden',
                            flexShrink: 0,
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center'
                          }}
                        >
                          {p?.imageUrl ? (
                            <img 
                              src={p.imageUrl.startsWith('http') ? p.imageUrl : `${axios.defaults.baseURL || ''}${p.imageUrl}`} 
                              alt={p?.name} 
                              style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
                              onError={(e) => { e.target.style.display = 'none'; e.target.parentElement.innerHTML = '<span style="font-size:12px;color:#999">IMG</span>'; }}
                            />
                          ) : (
                            <Typography variant="caption" color="text.secondary">
                              IMG
                            </Typography>
                          )}
                        </Box>

                        <Box sx={{ flex: 1, minWidth: 0 }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                            <Typography fontWeight={800} sx={{ flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                              {p?.name}
                            </Typography>
                            <IconButton size="small" onClick={() => openEditProduct(p)} title="Edit product">
                              <EditOutlinedIcon fontSize="small" />
                            </IconButton>
                            <IconButton size="small" onClick={(e) => { e.stopPropagation(); deleteProduct(p); }} color="error" title="Delete product">
                              <DeleteOutlineIcon fontSize="small" />
                            </IconButton>
                          </Box>

                          <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap', mt: 0.5 }}>
                            <Chip size="small" label={p?.category || 'Others'} />
                            <Chip size="small" color={p?.isPublished ? 'success' : 'default'} label={p?.isPublished ? 'Published' : 'Draft'} />
                            {p?.isSpecial && <Chip size="small" color="warning" label="Special" />}
                            {p?.isCombo && <Chip size="small" color="secondary" label="Combo" />}
                          </Stack>

                          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
                            {form.currency?.symbol} {Number(p?.price || 0) || 0}
                          </Typography>

                          <Box sx={{ display: 'flex', gap: 1, mt: 1, flexWrap: 'wrap' }}>
                            <Button
                              size="small"
                              variant={p?.isPublished ? 'outlined' : 'contained'}
                              onClick={() => togglePublish(p)}
                            >
                              {p?.isPublished ? 'Unpublish' : 'Publish'}
                            </Button>
                            <FormControlLabel
                              control={<Switch size="small" checked={Boolean(p?.isSpecial)} onChange={() => toggleSpecial(p)} />}
                              label="Special"
                              sx={{ ml: 0.5 }}
                            />
                            <FormControlLabel
                              control={<Switch size="small" checked={Boolean(p?.isCombo)} onChange={() => toggleCombo(p)} />}
                              label="Combo"
                              sx={{ ml: 0.5 }}
                            />
                          </Box>
                        </Box>
                      </Box>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            )}

            <Divider sx={{ my: 3 }} />

            <Typography variant="subtitle1" fontWeight={700} gutterBottom>
              Branding
            </Typography>
            <Grid container spacing={2}>
              <Grid item xs={12} md={6}>
                <Button variant="outlined" component="label" fullWidth>
                  Upload Logo (max 5MB)
                  <input
                    hidden
                    type="file"
                    accept="image/*"
                    onChange={(e) => uploadLogo(e.target.files?.[0])}
                  />
                </Button>
                {form.branding.logoUrl ? (
                  <Box sx={{ mt: 1 }}>
                    <img
                      src={form.branding.logoUrl.startsWith('http') ? form.branding.logoUrl : `${axios.defaults.baseURL || ''}${form.branding.logoUrl}`}
                      alt="Logo"
                      style={{ height: 48, width: 'auto' }}
                      onError={(e) => { console.error('Logo load error:', form.branding.logoUrl); }}
                    />
                  </Box>
                ) : null}
              </Grid>

              <Grid item xs={12}>
                <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
                  Banners & Placement
                </Typography>
                <Button variant="outlined" component="label" fullWidth>
                  Upload Banner Media (image/video, max 5MB)
                  <input
                    hidden
                    type="file"
                    accept="image/*,video/*"
                    onChange={(e) => uploadBannerMedia(e.target.files?.[0])}
                  />
                </Button>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
                  {mediaProcessing ? 'Compressing video in browser (ffmpeg.wasm)...' : 'Videos larger than 5MB will be compressed in browser before upload. Configure where each banner appears below.'}
                </Typography>

                {/* Banner List with Placement Controls */}
                {Array.isArray(form.banners) && form.banners.length > 0 && (
                  <Box sx={{ mt: 2 }}>
                    {form.banners.map((banner, idx) => (
                      <Paper key={idx} sx={{ p: 2, mb: 2, bgcolor: '#f9fafb' }}>
                        <Grid container spacing={2} alignItems="center">
                          <Grid item xs={12} sm={3}>
                            <Box sx={{ 
                              width: '100%', 
                              height: 80, 
                              borderRadius: 1, 
                              overflow: 'hidden',
                              bgcolor: '#e5e7eb'
                            }}>
                              {banner.type === 'video' ? (
                                <video src={banner.url} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                              ) : (
                                <img src={banner.url} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
                              )}
                            </Box>
                          </Grid>
                          <Grid item xs={12} sm={4}>
                            <TextField
                              fullWidth
                              select
                              size="small"
                              label="Placement"
                              value={banner.placement || 'top'}
                              onChange={(e) => {
                                const newBanners = [...form.banners];
                                newBanners[idx] = { ...newBanners[idx], placement: e.target.value };
                                setForm((prev) => ({ ...prev, banners: newBanners }));
                              }}
                            >
                              <MenuItem value="top">Top (Header Carousel)</MenuItem>
                              <MenuItem value="after-row-3">After 3rd Product Row</MenuItem>
                              <MenuItem value="after-row-6">After 6th Product Row</MenuItem>
                              <MenuItem value="after-row-9">After 9th Product Row</MenuItem>
                              <MenuItem value="bottom">Bottom (Before Footer)</MenuItem>
                            </TextField>
                          </Grid>
                          <Grid item xs={12} sm={3}>
                            <FormControlLabel
                              control={
                                <Switch
                                  size="small"
                                  checked={banner.showInCarousel !== false}
                                  onChange={(e) => {
                                    const newBanners = [...form.banners];
                                    newBanners[idx] = { ...newBanners[idx], showInCarousel: e.target.checked };
                                    setForm((prev) => ({ ...prev, banners: newBanners }));
                                  }}
                                />
                              }
                              label="Show in Carousel"
                            />
                          </Grid>
                          <Grid item xs={12} sm={2}>
                            <Button
                              size="small"
                              color="error"
                              onClick={() => {
                                setForm((prev) => ({
                                  ...prev,
                                  banners: prev.banners.filter((_, i) => i !== idx)
                                }));
                              }}
                            >
                              Remove
                            </Button>
                          </Grid>
                        </Grid>
                      </Paper>
                    ))}
                  </Box>
                )}
              </Grid>

              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Primary Color"
                  type="color"
                  value={form.branding.primaryColor}
                  onChange={updateBranding('primaryColor')}
                  InputProps={{ sx: { height: 56 } }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Accent Color"
                  type="color"
                  value={form.branding.accentColor}
                  onChange={updateBranding('accentColor')}
                  InputProps={{ sx: { height: 56 } }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Text Color"
                  type="color"
                  value={form.branding.textColor}
                  onChange={updateBranding('textColor')}
                  InputProps={{ sx: { height: 56 } }}
                />
              </Grid>
              <Grid item xs={12} md={3}>
                <TextField
                  fullWidth
                  label="Background Color"
                  type="color"
                  value={form.branding.backgroundColor}
                  onChange={updateBranding('backgroundColor')}
                  InputProps={{ sx: { height: 56 } }}
                />
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  select
                  label="Desktop Theme Style"
                  value={form.branding.desktopTheme || 'swiggy'}
                  onChange={updateBranding('desktopTheme')}
                  helperText="Choose how your store looks on desktop/laptop"
                >
                  <MenuItem value="swiggy">Swiggy Style - Card Grid with Side Cart</MenuItem>
                  <MenuItem value="zomato">Zomato Style - List View with Sticky Cart</MenuItem>
                  <MenuItem value="ubereats">Uber Eats Style - Large Cards with Bottom Cart</MenuItem>
                  <MenuItem value="doordash">DoorDash Style - Compact Grid with Floating Cart</MenuItem>
                  <MenuItem value="grubhub">GrubHub Style - Wide Cards with Right Panel</MenuItem>
                  <MenuItem value="deliveroo">Deliveroo Style - Minimal Cards with Drawer Cart</MenuItem>
                  <MenuItem value="postmates">Postmates Style - Photo Focus with Overlay Cart</MenuItem>
                  <MenuItem value="seamless">Seamless Style - Classic List with Fixed Cart</MenuItem>
                  <MenuItem value="caviar">Caviar Style - Premium Grid with Elegant Cart</MenuItem>
                  <MenuItem value="instacart">Instacart Style - Category Tabs with Quick Add</MenuItem>
                </TextField>
              </Grid>

              <Grid item xs={12} md={6}>
                <TextField
                  fullWidth
                  select
                  label="Mobile Theme Style"
                  value={form.branding.mobileTheme || 'swiggy'}
                  onChange={updateBranding('mobileTheme')}
                  helperText="Choose how your store looks on mobile phones"
                >
                  <MenuItem value="swiggy">Swiggy Mobile - Bottom Sheet Cart</MenuItem>
                  <MenuItem value="zomato">Zomato Mobile - Slide Up Cart</MenuItem>
                  <MenuItem value="ubereats">Uber Eats Mobile - Full Screen Cart</MenuItem>
                  <MenuItem value="doordash">DoorDash Mobile - Sticky Bottom Bar</MenuItem>
                  <MenuItem value="grubhub">GrubHub Mobile - Drawer Cart</MenuItem>
                  <MenuItem value="deliveroo">Deliveroo Mobile - Modal Cart</MenuItem>
                  <MenuItem value="postmates">Postmates Mobile - Expandable Footer</MenuItem>
                  <MenuItem value="seamless">Seamless Mobile - Fixed Bottom Cart</MenuItem>
                  <MenuItem value="caviar">Caviar Mobile - Elegant Slide Cart</MenuItem>
                  <MenuItem value="instacart">Instacart Mobile - Quick View Cart</MenuItem>
                </TextField>
              </Grid>
            </Grid>

            <Divider sx={{ my: 3 }} />

            <Box sx={{ mb: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', mb: 2 }}>
                <Typography variant="subtitle1" fontWeight={700}>
                  Live Preview
                </Typography>
                <ToggleButtonGroup
                  value={previewDevice}
                  exclusive
                  onChange={(e, val) => val && setPreviewDevice(val)}
                  size="small"
                >
                  <ToggleButton value="desktop">
                    <ComputerIcon fontSize="small" sx={{ mr: 0.5 }} />
                    Desktop
                  </ToggleButton>
                  <ToggleButton value="mobile">
                    <PhoneAndroidIcon fontSize="small" sx={{ mr: 0.5 }} />
                    Mobile
                  </ToggleButton>
                </ToggleButtonGroup>
              </Box>
              <Box sx={{ width: '100%', maxWidth: '100%', minWidth: 0, overflow: 'hidden', position: 'relative' }}>
                <LiveStorePreview
                  branding={form.branding}
                  storeName={form.storeName}
                  products={products}
                  banners={form.banners}
                  currency={form.currency}
                  isMobile={previewDevice === 'mobile'}
                />
              </Box>
            </Box>

            <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
              <Button
                variant="contained"
                onClick={saveStore}
                disabled={saving}
                startIcon={saving ? <CircularProgress size={18} /> : null}
              >
                Save
              </Button>
              <Button
                variant="outlined"
                onClick={() => storeLink && navigator.clipboard.writeText(storeLink)}
                disabled={!storeLink}
              >
                Copy Store Link
              </Button>
            </Box>
          </>
        )}
      </Paper>

      <Dialog open={productDialogOpen} onClose={() => setProductDialogOpen(false)} fullWidth maxWidth="md">
        <DialogTitle>
          {productForm?._id ? 'Edit Product' : 'Add Product'}
          <Box sx={{ mt: 1 }}>
            <FormControlLabel
              control={
                <Switch
                  checked={productForm?.sourceType === 'INVENTORY'}
                  onChange={(e) => {
                    const newType = e.target.checked ? 'INVENTORY' : 'PRODUCT';
                    setProductForm((prev) => ({ ...prev, sourceType: newType, sourceId: '' }));
                    loadSourceList(newType);
                  }}
                />
              }
              label={productForm?.sourceType === 'INVENTORY' ? 'From Inventory (Stock Managed)' : 'From Products (Menu Items)'}
            />
          </Box>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={2} sx={{ mt: 0.5 }}>
            {!productForm?.sourceId ? (
              <>
                <Grid item xs={12}>
                  <Tabs value={sourceTab} onChange={(e, val) => setSourceTab(val)} sx={{ mb: 1, borderBottom: 1, borderColor: 'divider' }}>
                    <Tab label={`All Items (${sourceList.length})`} />
                    <Tab label={`Special Items (${specialComboItems.filter(p => p.isSpecial).length})`} />
                    <Tab label={`Combo Deals (${specialComboItems.filter(p => p.isCombo).length})`} />
                  </Tabs>
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    placeholder="Search products..."
                    value={productPickerSearch}
                    onChange={(e) => setProductPickerSearch(e.target.value)}
                    size="small"
                  />
                </Grid>
                <Grid item xs={12}>
                  <Box sx={{ maxHeight: 400, overflowY: 'auto', border: '1px solid #ddd', borderRadius: 1 }}>
                    {sourceLoading ? (
                      <Box sx={{ p: 3, textAlign: 'center' }}>
                        <CircularProgress size={32} />
                        <Typography sx={{ mt: 1 }}>Loading {productForm?.sourceType === 'INVENTORY' ? 'inventory items' : 'products'}...</Typography>
                      </Box>
                    ) : productForm?.sourceType === 'INVENTORY' && sourceList.length === 0 && !String(form?.deliveryAreas?.[0]?.locationId || '').trim() ? (
                      <Box sx={{ p: 3, textAlign: 'center' }}>
                        <Alert severity="warning">
                          <Typography variant="body2" fontWeight={600}>No Warehouse Location Configured</Typography>
                          <Typography variant="body2" sx={{ mt: 1 }}>
                            To add inventory products, you must first configure at least one delivery area with a warehouse location in the "Delivery Areas" section above.
                          </Typography>
                        </Alert>
                      </Box>
                    ) : (
                      <Table size="small">
                        <TableHead>
                          <TableRow>
                            <TableCell padding="checkbox">
                              <Switch
                                size="small"
                                checked={selectedProducts.length === sourceList.length && sourceList.length > 0}
                                indeterminate={selectedProducts.length > 0 && selectedProducts.length < sourceList.length}
                                onChange={(e) => {
                                  if (e.target.checked) {
                                    // Only select products that are not already added
                                    const notAddedProducts = sourceList.filter(x => 
                                      !products.some(p => String(p?.sourceId) === String(x?._id) && p?.sourceType === productForm?.sourceType)
                                    );
                                    setSelectedProducts(notAddedProducts.map(x => String(x?._id)));
                                  } else {
                                    setSelectedProducts([]);
                                  }
                                }}
                              />
                            </TableCell>
                            <TableCell>Image</TableCell>
                            <TableCell>Name</TableCell>
                            <TableCell>Main Category</TableCell>
                            <TableCell>POS Category</TableCell>
                            <TableCell align="right">Cost</TableCell>
                            <TableCell align="right">Price</TableCell>
                            {productForm?.sourceType === 'INVENTORY' && <TableCell align="right">Stock</TableCell>}
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {(sourceTab === 0 ? sourceList : sourceTab === 1 ? specialComboItems.filter(p => p.isSpecial) : specialComboItems.filter(p => p.isCombo))
                            .filter((x) => {
                              // Filter by search
                              if (!productPickerSearch) return true;
                              const search = productPickerSearch.toLowerCase();
                              return (
                                (x?.name || '').toLowerCase().includes(search) ||
                                (x?.mainCategoryName || x?.category || '').toLowerCase().includes(search) ||
                                (x?.posCategoryName || '').toLowerCase().includes(search)
                              );
                            })
                            .map((x) => {
                              const imgSrc = x?.imageUrl ? (x.imageUrl.startsWith('http') ? x.imageUrl : `${axios.defaults.baseURL || ''}${x.imageUrl}`) : '';
                              const isSelected = selectedProducts.includes(String(x?._id));
                              // Check if this product is already added to the store (by sourceId)
                              const isAlreadyAdded = products.some(p => String(p?.sourceId) === String(x?._id) && p?.sourceType === productForm?.sourceType);
                              return (
                              <TableRow key={String(x?._id)} hover selected={isSelected} sx={{ opacity: isAlreadyAdded ? 0.5 : 1, bgcolor: isAlreadyAdded ? '#f5f5f5' : 'inherit' }}>
                                <TableCell padding="checkbox">
                                  <Switch
                                    size="small"
                                    checked={isSelected || isAlreadyAdded}
                                    disabled={isAlreadyAdded}
                                    onChange={(e) => {
                                      if (e.target.checked) {
                                        setSelectedProducts(prev => [...prev, String(x?._id)]);
                                      } else {
                                        setSelectedProducts(prev => prev.filter(id => id !== String(x?._id)));
                                      }
                                    }}
                                  />
                                </TableCell>
                                <TableCell>
                                  {imgSrc ? (
                                    <img src={imgSrc} alt="" style={{ width: 48, height: 48, objectFit: 'cover', borderRadius: 4 }} onError={(e) => { e.target.style.display = 'none'; }} />
                                  ) : (
                                    <Box sx={{ width: 48, height: 48, bgcolor: '#f0f0f0', borderRadius: 1 }} />
                                  )}
                                </TableCell>
                                <TableCell>
                                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                    {x?.name || '-'}
                                    {isAlreadyAdded && (
                                      <Chip label="Added" size="small" color="success" sx={{ height: 20, fontSize: '0.7rem' }} />
                                    )}
                                  </Box>
                                </TableCell>
                                <TableCell>{x?.mainCategoryName || '-'}</TableCell>
                                <TableCell>{x?.posCategoryName || '-'}</TableCell>
                                <TableCell align="right">{Number(x?.cost || 0).toFixed(2)}</TableCell>
                                <TableCell align="right">{Number(x?.price || x?.sellingPrice || 0).toFixed(2)}</TableCell>
                                {productForm?.sourceType === 'INVENTORY' && <TableCell align="right">{x?.stock || 0}</TableCell>}
                              </TableRow>
                            );
                            })}
                        </TableBody>
                      </Table>
                    )}
                  </Box>
                </Grid>
                {selectedProducts.length > 0 && (
                  <Grid item xs={12}>
                    <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', p: 2, bgcolor: '#e3f2fd', borderRadius: 1 }}>
                      <Typography variant="body2" sx={{ flex: 1 }}>
                        <strong>{selectedProducts.length}</strong> product{selectedProducts.length > 1 ? 's' : ''} selected
                      </Typography>
                      <Button
                        variant="contained"
                        size="small"
onClick={async () => {
                          setProductSaving(true);
                          try {
                            let successCount = 0;
                            for (const id of selectedProducts) {
                              // Find in sourceList (products/inventory) OR specialComboItems
                              const picked = sourceList.find(x => String(x?._id) === id) || specialComboItems.find(x => String(x?._id) === id);
                              if (!picked) {
                                console.warn('Item not found:', id);
                                continue;
                              }
                              
                              // Determine sourceType based on where item came from
                              let itemSourceType = productForm?.sourceType || 'PRODUCT';
                              if (picked.isSpecial || picked.isCombo) {
                                itemSourceType = 'SPECIAL'; // Mark special/combo items
                              }
                              
                              const payload = {
                                sourceType: itemSourceType,
                                sourceId: id,
                                trackStock: productForm?.sourceType === 'INVENTORY',
                                maxQtyPerOrder: 0,
                                cost: Number(picked?.cost || 0) || 0,
                                sellingPrice: Number(picked?.sellingPrice || picked?.price || 0) || 0,
                                mainCategoryId: picked?.mainCategoryId || '',
                                mainCategoryName: picked?.mainCategoryName || '',
                                posCategoryId: picked?.posCategoryId || '',
                                posCategoryName: picked?.posCategoryName || '',
                                images: Array.isArray(picked?.images) ? picked.images : [],
                                media: [],
                                name: picked?.name || '',
                                description: '',
                                category: picked?.category || picked?.mainCategoryName || picked?.posCategoryName || 'Others',
                                price: Number(picked?.price || picked?.sellingPrice || 0) || 0,
                                mrp: 0,
                                imageUrl: picked?.imageUrl || (Array.isArray(picked?.images) ? picked.images?.[0] : '') || '',
                                isVeg: false,
                                isAvailable: true,
                                isPublished: false,
                                isSpecial: Boolean(picked?.isSpecial),
                                isCombo: Boolean(picked?.isCombo),
                                productList: Array.isArray(picked?.productList) ? picked.productList : [],
                                taxes: Array.isArray(picked?.taxes) ? picked.taxes.map(tax => ({
                                  taxId: String(tax?.taxId || tax?._id || ''),
                                  taxName: String(tax?.taxName || tax?.name || ''),
                                  taxPercentage: Number(tax?.taxPercentage || tax?.amount || 0)
                                })) : [],
                                taxIncluded: Boolean(picked?.taxIncluded || picked?.includedPrice),
                                sortOrder: 0
                              };
                              try {
                                const res = await axios.post('/api/ecommerce-store/product/save', payload, HEADERS);
                                if (res.data?.success) {
                                  successCount++;
                                }
                              } catch (e) {
                                console.error('Failed to save product:', picked?.name, e);
                              }
                            }
                            
                            // Close dialog first, then reload and show message
                            const count = successCount;
                            setProductSaving(false);
                            setSelectedProducts([]);
                            setProductDialogOpen(false);
                            
                            if (count > 0) {
                              // Use requestAnimationFrame to ensure dialog is fully closed
                              requestAnimationFrame(() => {
                                loadProducts().then(() => {
                                  Swal.fire({ icon: 'success', title: `Added ${count} product${count > 1 ? 's' : ''}`, timer: 1500, showConfirmButton: false });
                                });
                              });
                            } else {
                              Swal.fire('Error', 'Failed to add products', 'error');
                            }
                          } catch (e) {
                            setProductSaving(false);
                            Swal.fire('Error', e?.message || 'Failed to add products', 'error');
                          }
                        }}
                        disabled={productSaving}
                      >
                        Add {selectedProducts.length} Product{selectedProducts.length > 1 ? 's' : ''}
                      </Button>
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => setSelectedProducts([])}
                      >
                        Clear
                      </Button>
                    </Box>
                  </Grid>
                )}
              </>
            ) : (
              <>
                <Grid item xs={12}>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, p: 2, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                    {productForm?.imageUrl && (() => {
                      const imgSrc = productForm.imageUrl.startsWith('http') ? productForm.imageUrl : `${axios.defaults.baseURL || ''}${productForm.imageUrl}`;
                      return <img src={imgSrc} alt="" style={{ width: 80, height: 80, objectFit: 'cover', borderRadius: 8 }} onError={(e) => { e.target.style.display = 'none'; }} />;
                    })()}
                    <Box sx={{ flex: 1 }}>
                      <Typography variant="h6">{productForm?.name}</Typography>
                      <Typography variant="body2" color="text.secondary">
                        {productForm?.mainCategoryName} {productForm?.posCategoryName && `• ${productForm.posCategoryName}`}
                      </Typography>
                      <Typography variant="body2" sx={{ mt: 0.5 }}>
                        Cost: <strong>{Number(productForm?.cost || 0).toFixed(2)}</strong>
                      </Typography>
                    </Box>
                    <Button
                      size="small"
                      onClick={() => {
                        setProductForm((prev) => ({ ...prev, sourceId: '' }));
                        setProductPickerSearch('');
                      }}
                    >
                      Change
                    </Button>
                  </Box>
                </Grid>

                <Grid item xs={12}>
                  <Divider sx={{ my: 1 }}>Product Details</Divider>
                </Grid>

                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Product Name"
                    value={productForm.name}
                    onChange={(e) => setProductForm((prev) => ({ ...prev, name: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <TextField
                    fullWidth
                    label="Display Category"
                    value={productForm.category}
                    onChange={(e) => setProductForm((prev) => ({ ...prev, category: e.target.value }))}
                    helperText="Optional: Override category for display"
                  />
                </Grid>

                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Description"
                    value={productForm.description}
                    onChange={(e) => setProductForm((prev) => ({ ...prev, description: e.target.value }))}
                    multiline
                    minRows={2}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Divider sx={{ my: 1 }}>Pricing</Divider>
                </Grid>

                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Your Selling Price"
                    type="number"
                    value={productForm.price}
                    onChange={(e) => setProductForm((prev) => ({ ...prev, price: e.target.value }))}
                    helperText="Final price for buyers"
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="MRP (optional)"
                    type="number"
                    value={productForm.mrp}
                    onChange={(e) => setProductForm((prev) => ({ ...prev, mrp: e.target.value }))}
                  />
                </Grid>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    label="Max Qty Per Order"
                    type="number"
                    value={productForm.maxQtyPerOrder}
                    onChange={(e) => setProductForm((prev) => ({ ...prev, maxQtyPerOrder: e.target.value }))}
                    helperText="0 = unlimited"
                  />
                </Grid>

                <Grid item xs={12}>
                  <Divider sx={{ my: 1 }}>Media & Images</Divider>
                </Grid>

                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Switch
                        checked={Boolean(productForm.useExistingMedia)}
                        onChange={(e) => setProductForm((prev) => ({ ...prev, useExistingMedia: e.target.checked }))}
                      />
                    }
                    label="Use existing product images (no upload needed)"
                  />
                  <Typography variant="caption" color="text.secondary" display="block" sx={{ ml: 4 }}>
                    Check this to use images from master product. Uncheck to upload new images.
                  </Typography>
                </Grid>

                {!productForm.useExistingMedia && (
                  <>
                    <Grid item xs={12} md={6}>
                      <Button variant="outlined" component="label" fullWidth>
                        Upload Product Image (max 5MB)
                        <input hidden type="file" accept="image/*" onChange={(e) => uploadProductImage(e.target.files?.[0])} />
                      </Button>
                      {productForm.imageUrl && (
                        <Box sx={{ mt: 1, textAlign: 'center' }}>
                          <img src={productForm.imageUrl} alt="Product" style={{ maxHeight: 120, width: 'auto', borderRadius: 8 }} />
                        </Box>
                      )}
                    </Grid>

                    <Grid item xs={12} md={6}>
                      <Typography variant="subtitle2" fontWeight={700} sx={{ mb: 1 }}>
                        Banners & Placement
                      </Typography>
                      <Button variant="outlined" component="label" fullWidth>
                        Upload Banner (Image/Video, max 10MB)
                        <input hidden type="file" accept="image/*,video/*" onChange={(e) => uploadBannerMedia(e.target.files?.[0])} />
                      </Button>
                      <Typography variant="caption" color="text.secondary" display="block" sx={{ mt: 0.5 }}>
                        Configure where each banner appears on your store
                      </Typography>
                      {Array.isArray(productForm.media) && productForm.media.length > 0 && (
                        <Stack direction="row" spacing={1} sx={{ mt: 1, flexWrap: 'wrap' }}>
                          {productForm.media.map((m, idx) => (
                            <Chip
                              key={m?.url || idx}
                              size="small"
                              label={m?.mimeType?.startsWith('video/') ? `Video ${idx + 1}` : `Image ${idx + 1}`}
                              onDelete={() =>
                                setProductForm((prev) => ({
                                  ...prev,
                                  media: (prev.media || []).filter((x) => x?.url !== m?.url)
                                }))
                              }
                            />
                          ))}
                        </Stack>
                      )}
                    </Grid>
                  </>
                )}

                {productForm.useExistingMedia && productForm.images && productForm.images.length > 0 && (
                  <Grid item xs={12}>
                    <Typography variant="body2" sx={{ mb: 1 }}>Existing images from master product:</Typography>
                    <Stack direction="row" spacing={1} sx={{ flexWrap: 'wrap' }}>
                      {productForm.images.slice(0, 5).map((img, idx) => {
                        const imgSrc = img ? (img.startsWith('http') ? img : `${axios.defaults.baseURL || ''}${img}`) : '';
                        return (
                        <Box key={idx} sx={{ width: 80, height: 80, border: '1px solid #ddd', borderRadius: 1, overflow: 'hidden' }}>
                          <img src={imgSrc} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} onError={(e) => { e.target.style.display = 'none'; }} />
                        </Box>
                      );
                      })}
                    </Stack>
                  </Grid>
                )}

                <Grid item xs={12}>
                  <Divider sx={{ my: 1 }}>Settings</Divider>
                </Grid>

                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={<Switch checked={Boolean(productForm.isVeg)} onChange={(e) => setProductForm((prev) => ({ ...prev, isVeg: e.target.checked }))} />}
                    label="Veg"
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={<Switch checked={Boolean(productForm.isAvailable)} onChange={(e) => setProductForm((prev) => ({ ...prev, isAvailable: e.target.checked }))} />}
                    label="Available"
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={<Switch checked={Boolean(productForm.isPublished)} onChange={(e) => setProductForm((prev) => ({ ...prev, isPublished: e.target.checked }))} />}
                    label="Published"
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    fullWidth
                    label="Sort Order"
                    type="number"
                    size="small"
                    value={productForm.sortOrder}
                    onChange={(e) => setProductForm((prev) => ({ ...prev, sortOrder: e.target.value }))}
                  />
                </Grid>
              </> 
            )}
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setProductDialogOpen(false)} variant="outlined">
            Cancel
          </Button>
          <Button onClick={saveProduct} disabled={productSaving} variant="contained" startIcon={productSaving ? <CircularProgress size={18} /> : null}>
            Save Product
          </Button>
        </DialogActions>
      </Dialog>

      {/* Animation Selector Dialog */}
      <AnimationSelectorDialog
        open={animationDialogOpen}
        onClose={() => setAnimationDialogOpen(false)}
        product={selectedProductForAnimation}
        animationLibrary={ANIMATION_LIBRARY}
        settings={animationSettings}
        onSettingsChange={setAnimationSettings}
        onSave={async (settings) => {
          try {
            const payload = {
              ...selectedProductForAnimation,
              animation: settings
            };
            const res = await axios.post('/api/ecommerce-store/product/save', payload, HEADERS);
            if (res.data?.success) {
              Swal.fire({ icon: 'success', title: 'Animation settings saved!', timer: 1500, showConfirmButton: false });
              setAnimationDialogOpen(false);
              await loadProducts();
            } else {
              Swal.fire('Error', res.data?.message || 'Failed to save animation settings', 'error');
            }
          } catch (e) {
            Swal.fire('Error', e?.response?.data?.message || e.message || 'Failed to save animation settings', 'error');
          }
        }}
      />
    </Box>
  );
};

export default SellerEcommerceDashboard;
